// angular
import {
    Component,
    OnInit,
    OnDestroy,
    ViewChild,
    Input,
    SimpleChanges,
    OnChanges,
    Output,
    EventEmitter,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// services
import { AuthService } from '../../../core/auth.service';
import { BaseService } from '../../../shared/base.service';
// others
import { BaseComponent } from '../../../shared/base.component';
import { AppService } from '../../../app.service';
import { PatientService } from '../../patient.service';

import { AccordionComponent } from 'ngx-bootstrap/accordion';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'manual-diagnosis-component',
    templateUrl: 'manual-diagnosis.component.html',
    styleUrls: ['manual-diagnosis.component.scss'],
    providers: [
        BaseService
    ]
})

export class ManualDiagnosisComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {
    @Input() patientId: number; // Structured diagnosis items, to be used in tree-selector.
    @Input() currentEditDiagnosis;
    @Input() closeAfterEdit : boolean = false;

    @Output() updateDiagnosis = new EventEmitter();

    diagnosisList = [];
    selectedDiagnosisIds = [];
    diagnosesSub: Subscription;
    editMode = false;
    
    @ViewChild('accordion', { static: false }) accordionComp: AccordionComponent;

    constructor(
        public authService: AuthService,
        public baseService: BaseService,
        public router: Router,
        public appService: AppService,
        public route: ActivatedRoute,
        public patientService: PatientService,
        public translate: TranslateService
    ) {
        super(authService, router, baseService, appService);
    }

    ngOnInit() {
        this.initData();
        this.diagnosesSub = this.appService.subscribe('diagnoses', data => {
            if (data['selectedDiagnosesAreUpdated']) {
                this.initData();
                let currentOrder = this.patientService.selectedDiagnoses.length > 0 ? this.patientService.selectedDiagnoses.length : 1
                this.patientService.currentlySelectedOrder = currentOrder;
                this.patientService.nextDiagnosisOrder = currentOrder + 1;
                if (this.closeAfterEdit) {
                    this.updateDiagnosis.emit();
                }
            }
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['currentEditDiagnosis'] && changes['currentEditDiagnosis']['currentValue']) {
            this.editMode = true;
            this.patientService.currentlySelectedOrder = this.currentEditDiagnosis['pivot']['order'];
        }
    }

    ngOnDestroy() {
        if (this.diagnosesSub) {
            this.diagnosesSub.unsubscribe();
        }
    }

    initData() {
        this.selectedDiagnosisIds = [];
        this.diagnosisList = this.patientService.diagnoses;
        this.patientService.selectedDiagnoses.forEach(diagnosis => {
            this.selectedDiagnosisIds.push(diagnosis['id']);
        });
        this.patientService.patientId = this.patientId;
    }

    add(item) {
        if (!this.editMode) {
            this.patientService.currentlySelectedOrder++;
        }
        this.patientService.addDiagnosis(item);
        this.currentEditDiagnosis = item;
        this.editMode = false;
    }

    remove(item) {
       this.patientService.deleteDiagnosis(item);
    }
}
